import { type OrganicStatsResponseDimensionEntry } from "../../gql-generated/types";
import { funnelAnalysisFieldsWithDimensionsCascadingOrderMap } from "../models";

export const sortStatsListInCascadingOrder = (
    statsList: readonly OrganicStatsResponseDimensionEntry[],
): OrganicStatsResponseDimensionEntry[] =>
    [...statsList].sort((stat1, stat2) => {
        const name1 = stat1.field?.fieldName;
        const name2 = stat2.field?.fieldName;
        const value1 = name1 ? funnelAnalysisFieldsWithDimensionsCascadingOrderMap[name1] : undefined;
        const value2 = name2 ? funnelAnalysisFieldsWithDimensionsCascadingOrderMap[name2] : undefined;

        // put metrics not from the ordering map in the end
        if ((!name1 || value1 === undefined) && (!name2 || value2 === undefined)) {
            return 0;
        }

        if (!name1 || value1 === undefined) {
            return 1;
        }

        if (!name2 || value2 === undefined) {
            return -1;
        }

        return value1 - value2;
    });
